import {
  startuse,
  stopuse,
  delete_activity,
  getpadAdverts,
  getCompanyAdvertDetail,
  addpadAdverts,
  setpadAdverts,
  updatepadAdverts,
} from '@/services/resourceCenter/advert';
import { asyncGetClient } from '@/utils/oss';

export default {
  namespace: 'ResourceCenter_advert',

  state: {
    indexData: {
      list: [],
      pagination: {},
    },
    current: {},
  },
  effects: {
    *enable({ payload }, { call, put }) {
      const { data, status } = yield call(startuse, payload);
      return data;
    },
    *disable({ payload }, { call, put }) {
      const { data, status } = yield call(stopuse, payload);
      return data;
    },
    *deleteActivity({ payload, callback }, { call, put }) {
      const { data, status } = yield call(delete_activity, payload);
      return data;
    },
    *get({ payload }, { call, put }) {
      const { status, data } = yield call(getpadAdverts, payload);
      if (status === 200) {
        yield put({
          type: 'saveData',
          payload: {
            list: data.data,
            pagination: {
              total: parseInt(data.total),
              pageSize: parseInt(data.per_page),
              current: parseInt(data.current_page),
            },
          },
        });
      }
    },
    *getDetail({ payload, callback }, { call, put }) {
      const { status, data } = yield call(getCompanyAdvertDetail, payload);
      if (status === 200) {
        yield put({
          type: 'saveCurrent',
          payload: data,
        });
      }
      return data;
    },
    *addpad({ payload, callback }, { call, put }) {
      const { data, status } = yield call(addpadAdverts, payload);
      return data;
    },
    // *setpad({ payload, callback }, { call, put }) {
    //   const { data, status } = yield call(setpadAdverts, payload);
    //   return data;
    // },
    *update({ payload, callback }, { call, put }) {
      const { data } = yield call(updatepadAdverts, payload);
      return data;
    },
    *fetchOssConfig() {
      return yield (async () => {
        let ossConfigs = {};

        try {
          ossConfigs = await asyncGetClient();
        } catch (error) {
          console.error(error);
          return;
        }
        return ossConfigs;
      })();
    },
  },

  reducers: {
    saveData(state, action) {
      return {
        ...state,
        indexData: action.payload,
      };
    },
    saveCurrent(state, action) {
      return {
        ...state,
        current: action.payload,
      };
    },
    save(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },
  },
};
